import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { expiresAt: String }
  static targets = ["display"]

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    const expires = new Date(this.expiresAtValue)
    const remaining = expires.getTime() - Date.now()

    if (remaining <= 0) {
      if (this.hasDisplayTarget) this.displayTarget.textContent = "00:00:00"
      if (this.timer) clearInterval(this.timer)
      return
    }

    const hours = Math.floor(remaining / 3_600_000)
    const minutes = Math.floor((remaining % 3_600_000) / 60_000)
    const seconds = Math.floor((remaining % 60_000) / 1000)
    const formatted = [ hours, minutes, seconds ]
      .map((value) => String(value).padStart(2, "0"))
      .join(":")

    if (this.hasDisplayTarget) this.displayTarget.textContent = formatted
  }
}
